export default __webpack_public_path__ + "static/media/icn_list_guide_3.dce6266c.svg";